// Predicate-generating function. Often useful outside of Underscore.
export default function constant(value) {
  return function() {
    return value;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/constant.js
// module id = 188
// module chunks = 0 1